import HENGE from "@henge-inc/global-types";
import HUI from "@henge-inc/ui/v1_2";
import { i as i_v1_1 } from "@henge-inc/ui/v1_1";

export type SelectOption = {
  readonly label: string;
  readonly value: string;
};

export type SelectControllerProps = {
  label: string;
  value: string;
  setValue: (value: string) => void;
  options: SelectOption[];
};

export const SelectController = ({
  value,
  setValue,
  options,
}: SelectControllerProps) => {
  return (
    <div className="w-full h-6 rounded-lg bg-[var(--gray50-alpha50)] hover:bg-[var(--gray50)] overflow-hidden relative flex items-center justify-between pl-2 pr-1 transition-colors">
      <select
        className="w-full h-full px-2 bg-transparent border-none outline-none cursor-pointer opacity-0 absolute inset-0"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <HUI.Text
        kind={HENGE.TEXT_KIND.small}
        weight={HENGE.TEXT_WEIGHT.medium}
        colour={HENGE.SEMANTIC_TEXT_COLOUR["text-primary"]}
        className="mr-1 select-none"
      >
        {options && options.filter((option) => option.value === value)[0].label}
      </HUI.Text>
      <div className="w-4 h-4 flex items-center justify-center">
        <i_v1_1.ChevronDown
          kind={HENGE.ICON_KIND.regular}
          size={HENGE.DETAILED_SIZE.small}
          colour={HENGE.SEMANTIC_TEXT_COLOUR["text-tertiary"]}
        />
      </div>
    </div>
  );
};
